// extracted by mini-css-extract-plugin
export default {"root":"payment_provider_form_root__2fKv6","submit_button":"payment_provider_form_submit_button__iitb3","footer":"payment_provider_form_footer__dSMLr"};